import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { SidebarService, ISidebar } from '../sidebar/sidebar.service';
import { Router } from '@angular/router';
import { LangService, Language } from 'src/app/shared/lang.service';
import { environment } from 'src/environments/environment';
import { getThemeColor, setThemeColor } from 'src/app/utils/util';
import { validate } from 'secure-password-validator';
import { SearchComponent } from '../search/search.component';

import { AuthService, GeneralService } from 'src/app/services/services';
import { apiRoutes } from 'src/app/constants/constants';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TopnavComponent implements OnInit, OnDestroy {

  @ViewChild('studentModal')
  private studentModalTemplate: TemplateRef<any>;

  modalRefRol: BsModalRef;
  @ViewChild('rolModal', { static: true })
  private rolModalTemplate: TemplateRef<any>;

  modalRefPassword: BsModalRef;
  @ViewChild('passwordModal', { static: true })
  private passwordModalTemplate: TemplateRef<any>;

  //Pin Modal
  modalRefPin: BsModalRef;
  @ViewChild('pinModal', { static: true })
  private pinModalTemplate: TemplateRef<any>;

  @ViewChild('searchModal', { static: true })
  private searchModalTemplate: SearchComponent;

  lstStudent: any[] = [];
  objStudent: any = null;
  modalRef: BsModalRef;

  buyUrl = environment.buyUrl;
  adminRoot = environment.adminRoot;
  sidebar: ISidebar;
  subscription: Subscription;
  displayName = 'Sarah Cortney';
  languages: Language[];
  currentLanguage: string;
  isSingleLang;
  isFullScreen = false;
  isDarkModeActive = false;
  searchKey = '';
  rolId: any;
  authRol: any;
  intRolId: any = -1;
  fotografia = "/assets/img/profiles/responsible.png";
  username = null;

  objCambio: any = {};
  indexTab: number = 1;
  authCaja: any;
  intCajaPuntoVentaId: number = 0;

  objPin: any = {};
  viewPinValue: boolean = true;
  viewPinRepeatedValue: boolean = true;
  showPassword: boolean = false;
  blnCompletePin: boolean = false;
  blnCompletePinRepeat: boolean = false;

  blnPassword: boolean = false;
  blnNewPassword: boolean = false;
  blnRepeatPassword: boolean = false;
  
  options = {
    minLength: 8,
    maxLength: 50,
    blackList: [],
    digits: true,
    letters: true,
    uppercase: true,
    lowercase: true,
    symbols: true
  };

  errors = {
    "MIN_LENGTH": 'La contraseña debe poseer minimo 8 caracteres.',
    "MAX_LENGTH": 'La contraseña no debe exceder 50 caracteres.',
    "DIGITS": 'La contraseña debe contener por lo menos 1 digito.',
    "LOWERCASE": 'La contraseña debe contener por lo menos 1 miniscula.',
    "UPPERCASE": 'La contraseña debe contener por lo menos 1 mayuscula.',
    "SYMBOLS": 'La contraseña debe contener por lo menos 1 simbolo.'
  };

  validPassword: boolean = false;
  arrPasswordErrors: string[] = [];

  constructor(
    private sidebarService: SidebarService,
    private authService: AuthService,
    private router: Router,
    private langService: LangService,
    private modalService: BsModalService,
    private generalService: GeneralService,
    private route: Router
  ) {
    this.languages = this.langService.supportedLanguages;
    this.currentLanguage = this.langService.languageShorthand;
    this.isSingleLang = this.langService.isSingleLang;
    this.isDarkModeActive = getThemeColor().indexOf('dark') > -1 ? true : false;
  }

  onDarkModeChange(event): void {
    let color = getThemeColor();
    if (color.indexOf('dark') > -1) {
      color = color.replace('dark', 'light');
    } else if (color.indexOf('light') > -1) {
      color = color.replace('light', 'dark');
    }
    setThemeColor(color);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }

  fullScreenClick(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  }

  @HostListener('document:fullscreenchange', ['$event'])
  handleFullscreen(event): void {
    if (document.fullscreenElement) {
      this.isFullScreen = true;
    } else {
      this.isFullScreen = false;
    }
  }

  togglePasswordVisibility(campo: number) {
    if (campo == 1) { this.blnPassword = !this.blnPassword }
    if (campo == 2) { this.blnNewPassword = !this.blnNewPassword }
    if (campo == 3) { this.blnRepeatPassword = !this.blnRepeatPassword }
    if (campo == 4) { this.showPassword = !this.showPassword }

  }

  onLanguageChange(lang): void {
    this.langService.language = lang.code;
    this.currentLanguage = this.langService.languageShorthand;
  }

  async ngOnInit(): Promise<void> {
    this.displayName = "";
    const objAuthData = this.authService.getAuthData();
    if (objAuthData.usuario.fotografia) {
      this.fotografia = objAuthData.usuario.fotografia;
      this.username = objAuthData.usuario.user;

    }

    this.subscription = this.sidebarService.getSidebar().subscribe(
      (res) => {
        this.sidebar = res;
      },
      (err) => {
        console.error(`An error occurred: ${err.message}`);
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  menuButtonClick = (
    e: { stopPropagation: () => void },
    menuClickCount: number,
    containerClassnames: string
  ) => {
    if (e) {
      e.stopPropagation();
    }

    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);

    this.sidebarService.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.sidebar.selectedMenuHasSubItems
    );
  }

  mobileMenuButtonClick = (
    event: { stopPropagation: () => void },
    containerClassnames: string
  ) => {
    if (event) {
      event.stopPropagation();
    }
    this.sidebarService.clickOnMobileMenu(containerClassnames);
  }

  onSignOut(): void {
    this.authService.logout();
  }

  searchKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    } else if (event.key === 'Escape') {
      const input = document.querySelector('.mobile-view');
      if (input && input.classList) {
        input.classList.remove('mobile-view');
      }
      this.searchKey = '';
    }
  }

  searchAreaClick(event): void {
    event.stopPropagation();
  }

  searchClick(event): void {
    if (window.innerWidth < environment.menuHiddenBreakpoint) {
      let elem = event.target;
      if (!event.target.classList.contains('search')) {
        if (event.target.parentElement.classList.contains('search')) {
          elem = event.target.parentElement;
        } else if (
          event.target.parentElement.parentElement.classList.contains('search')
        ) {
          elem = event.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
      } else {
        elem.classList.add('mobile-view');
      }
    } else {
      this.search();
    }
    event.stopPropagation();
  }

  openSearchModal() {
    this.searchModalTemplate.show();
  }

  search(): void {
    if (this.searchKey && this.searchKey.length > 1) {
      this.router.navigate([this.adminRoot + '/#'], {
        queryParams: { key: this.searchKey.toLowerCase().trim() },
      });
      this.searchKey = '';
    }
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event): void {
    const input = document.querySelector('.mobile-view');
    if (input && input.classList) {
      input.classList.remove('mobile-view');
    }
    this.searchKey = '';
  }

  selectStudent(student: any) {
    this.lstStudent.forEach(x => x.selected = false);
    student.selected = true;
    this.objStudent = student;
  }

  cambiarRolModal(indexTab: number = 1) {
    this.indexTab = indexTab;
    this.intRolId = this.authService.getRolId();
    this.authRol = this.authService.getArrRol();
    this.modalRefRol = this.modalService.show(this.rolModalTemplate, { backdrop: true, ignoreBackdropClick: true, class: 'modal-content modal-lg' });
  }

  submitCambioRol() {
    this.generalService.CreateOrUpdateDataResponse(apiRoutes.ROUTE_CAMBIO_ROL, { rolId: this.intRolId, cajaPuntoVentaId: this.intCajaPuntoVentaId }, 'post', false)
      .then((response: any) => {
        if (response && response.data) {
          this.authService.setCambioRol(response.data);
          this.modalRefRol.hide();
        }
      }).catch(error => {
        console.log(error);
      });
  }

  updatePasswordModal() {
    this.objCambio = {};
    this.modalRefPassword = this.modalService.show(this.passwordModalTemplate, { backdrop: true, ignoreBackdropClick: true, class: 'modal-content modal-lg' });
  }

  submitUpdatePassword() {
    if (!this.objCambio || !this.objCambio.newPassword || !this.objCambio.confirmPassword || this.objCambio.newPassword != this.objCambio.confirmPassword || !this.validPassword) return;
    const body = { passwordActual: this.objCambio.password, passwordNueva: this.objCambio.newPassword };
    this.generalService.CreateOrUpdateData(apiRoutes.ROUTE_RESET_PASSWORD, body, 'post').then((success: any) => {
      if (success) {
        this.hideModalPassword();
        this.route.navigate(
          ['/']
        );
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  classInput(input: any) {
    return { 'inputError': input.touched && input.invalid };
  }

  hideModalPassword() {
    this.modalRefPassword.hide();
    this.objCambio = {};
  }

  onChangePassword(event: any) {
    const password = event.target.value;
    const result = validate(password, this.options);
    this.validPassword = result.valid;
    this.arrPasswordErrors = result.errors;
  }

  configurarPin() {
    this.objPin = {};
    this.viewPinValue = true;
    this.viewPinRepeatedValue = true;
    this.blnCompletePin = false;
    this.blnCompletePinRepeat = false;
    this.modalRefPin = this.modalService.show(this.pinModalTemplate, { backdrop: true, ignoreBackdropClick: true, class: 'modal-content' });
  }

  hideModalPin() {
    this.modalRefPin.hide();
  }
  // this called every time when user changed the code
  onCodeChanged(code: string) {
    this.objPin.pin = code;
    this.blnCompletePin = false;
  }

  onCodeChanged2(code: string) {
    this.objPin.repeatPin = code;
    this.blnCompletePinRepeat = false;
  }

  // this called only if user entered full code
  onCodeCompleted(code: string) {
    this.objPin.pin = code;
    this.blnCompletePin = true;
    this.validatePinRepeated();
  }

  onCodeCompleted2(code: string) {
    this.objPin.repeatPin = code;
    this.blnCompletePinRepeat = true;
    this.validatePinRepeated();
  }

  validatePinRepeated() {
    if (this.objPin.password && this.objPin.password != '') {
      return this.objPin.pin == this.objPin.repeatPin;
    }
  }

  viewPinValueBln() {
    this.viewPinValue = !this.viewPinValue;
    return this.viewPinValue;
  }

  viewPinRepeatedValueBln() {
    this.viewPinRepeatedValue = !this.viewPinRepeatedValue;
    return this.viewPinValue;
  }

  submitConfiguratePin() {
    if (!this.validatePinRepeated()) return;
    const body = {
      passwordActual: this.objPin.password,
      nuevoPIN: this.objPin.pin
    }
    this.generalService.patchData(apiRoutes.ROUTE_CONFIGURAR_PIN, body).then((success: any) => {
      if (success) {
        this.hideModalPin();
      }
    }).catch((error) => {
      console.log(error);
    });
  }
}
